// components/common/NeuronResponsiveTabs.styles.ts
import { Theme } from "@mui/material";
import { COLORS } from "../../constant/color";
export const getResponsiveTabsStyles = (theme: Theme, activeTab: number) => ({
  container: {
    width: "100%",
    
  },
  selectWrapper: {
    width: "100%",
    maxWidth: 250,
    marginBottom: theme.spacing(2),
   
    
  },
  select: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    
  },
  tabs: {
    display: "flex",
  },
    tab: (index: number) => ({
      boxShadow: "none",
      opacity: 1,
      backgroundImage: "none",
    border: index === activeTab ? `1px solid ${theme.palette.divider}` : "none",
    borderBottom: index === activeTab ? "none" : "white",
    borderRadius: "6px 6px 0 0",
    backgroundColor: index === activeTab ? theme.palette.background.paper : "transparent",
    textTransform: "none",
    color:
      index === activeTab
        ? COLORS.light.textSecondary
        : theme.palette.text.primary,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontWeight: "bold",
    marginRight: theme.spacing(2),
     // backgroundColor: theme.palette.background.paper,
    
    "&:hover": {
      border: `1px solid ${theme.palette.divider}`,
      borderBottom: "none",
      borderRadius: "6px 6px 0 0",
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.secondary, // :point_left: Force text color same as active tab
      boxShadow: "none",
      opacity: 1,
      backgroundImage: "none",
    },
  }),
  tabContent: {
    marginTop: theme.spacing(0),
  },
});